/**
 * Props for `<sp-rating>` — a star rating, its numeric score, and an
 * optional link to the rating methodology. Stars are drawn for the score only: a rating of
 * 4.5 draws four full stars and a half star, with no empty stars after them.
 */
import { booleanAttribute } from "#ce/utils/props";

export const props = Object.freeze({
  /**
   * The score out of five. A missing or zero rating draws no stars and shows `no-rating`
   * in place of the score.
   *
   * @type {Number|String}
   * @default undefined
   * @storybook-control number
   */
  rating: {
    type: [Number, String],
    default: undefined,
  },
  /**
   * Hides the numeric score, leaving the stars alone.
   *
   * @type {Boolean|String}
   * @default false
   */
  noScore: booleanAttribute(),
  /**
   * Destination for the stars and the score. Without it they render as plain text.
   *
   * @type {String}
   * @default undefined
   */
  url: {
    type: String,
    default: undefined,
  },
  /**
   * Destination for the trailing info icon, which renders only when this is set.
   *
   * @type {String}
   * @default undefined
   */
  infoUrl: {
    type: String,
    default: undefined,
  },
  /**
   * `target` for every link the element renders.
   *
   * @type {String}
   * @default undefined
   */
  target: {
    type: String,
    default: undefined,
  },
  /**
   * Shown in place of the score when there is no rating.
   *
   * @type {String}
   * @default undefined
   */
  noRating: {
    type: String,
    default: undefined,
  },
});
